import { createSlice } from '@reduxjs/toolkit'
import {
  placeBetVideoPoker, getVideoPokerBets, getUnfinishedBet, dealVideoPoker
} from 'games/VidePoker/slice-thunk/videoPoker.thunk'
import { minus, plus } from 'number-precision'

const initialState = {
  betHistoryData: [],
  placedBet: [],
  myBetsData: {
    count: 0,
    rows: []
  },
  myBetsLoading: false,
  betInProgress: false,
  betStates: null,
  roundLock: false,
  openedCards: [],
  unfinishedBetAmount: null,
  wins: 0,
  losses: 0,
  profit: 0,
  wagered: 0
}

const {
  actions: {
    setPlacedBetsData,
    setPokerWinsCount,
    setPokerLossCount,
    setPokerProfit,
    setPokerWagered,
    resetLiveStats
  }, reducer
} = createSlice({
  name: 'videoPokerGame',
  initialState,
  reducers: {
    setPlacedBetsData: (state, action) => {
      return {
        ...state,
        betHistoryData: action.payload
      }
    },
    setPokerWinsCount: (state, action) => {
      return {
        ...state,
        wins: state.wins + 1
      }
    },
    setPokerLossCount: (state, action) => {
      return {
        ...state,
        losses: state.losses + 1
      }
    },
    setPokerProfit: (state, action) => {
      return {
        ...state,
        profit: plus(state.profit, minus(action.payload?.winningAmount ?? 0, action.payload?.betAmount ?? 0))
      }
    },
    setPokerWagered: (state, action) => {
      return {
        ...state,
        wagered: plus(state.wagered, action.payload)
      }
    },
    resetLiveStats: (state, action) => {
      return ({
        ...state,
        wins: 0,
        losses: 0,
        profit: 0,
        wagered: 0
      })
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVideoPokerBets.pending, (state, action) => {
        return {
          ...state,
          myBetsLoading: true
        }
      })
      .addCase(getVideoPokerBets.fulfilled, (state, action) => {
        return {
          ...state,
          myBetsData: action.payload,
          myBetsLoading: false
        }
      })
      .addCase(getVideoPokerBets.rejected, (state, action) => {
        return {
          ...state,
          myBetsLoading: false
        }
      })
      .addCase(placeBetVideoPoker.pending, (state, action) => {
        return {
          ...state,
          betInProgress: true,
          roundLock: false
        }
      })
      .addCase(placeBetVideoPoker.fulfilled, (state, action) => {
        return {
          ...state,
          placedBet: action.payload,
          roundLock: true,
          betInProgress: false,
          betStates: action.payload.betStates,
          openedCards: action.payload.betStates[0].cardsState

        }
      })
      .addCase(placeBetVideoPoker.rejected, (state, action) => {
        return {
          ...state,
          placedBet: null,
          betInProgress: false,
          roundLock: false
        }
      })
      .addCase(getUnfinishedBet.pending, (state, action) => {
        return {
          ...state
        }
      })
      .addCase(getUnfinishedBet.fulfilled, (state, action) => {
        if (action.payload?.hasUnfinishedBet) {
          const { unfinishedBet } = action.payload
          let betStates = null
          const roundLock = true
          let openedCards = []
          const betAmount = unfinishedBet?.betAmount
          if (unfinishedBet?.betStates && unfinishedBet.betStates.length > 0) {
            betStates = (unfinishedBet.betStates)
            openedCards = unfinishedBet.betStates[0].cardsState
          }
          return {
            ...state,
            roundLock,
            betStates,
            unfinishedBetAmount: betAmount,
            openedCards,
            stateLoaded: true
          }
        }
        return {
          ...state,
          stateLoaded: true
        }
      })
      .addCase(getUnfinishedBet.rejected, (state, action) => {
        return {
          ...state,
          stateLoaded: true
        }
      })
      .addCase(dealVideoPoker.pending, (state, action) => {
        return {
          ...state
        }
      })
      .addCase(dealVideoPoker.fulfilled, (state, action) => {
        return {
          ...state,
          roundLock: false,
          placedBet: action.payload,
          betStates: action.payload.betStates,
          openedCards: action.payload.betStates[0].cardsState

        }
      })
      .addCase(dealVideoPoker.rejected, (state, action) => {
        return {
          ...state
        }
      })
  }
})

export default reducer
export {
  setPlacedBetsData,
  setPokerWinsCount,
  setPokerLossCount,
  setPokerProfit,
  setPokerWagered,
  resetLiveStats
}
